import PropTypes from "prop-types";
import React from "react";

export const HotTub = (props) => {
  const { className, role, size, style } = props;

  return (
    <svg {...getProps()}>
      <path d="M4.4335 5.55C4.11127 5.55 3.83905 5.43889 3.61683 5.21667C3.39461 4.99444 3.2835 4.72222 3.2835 4.4C3.2835 4.07778 3.39461 3.80556 3.61683 3.58333C3.83905 3.36111 4.11127 3.25 4.4335 3.25C4.75572 3.25 5.02794 3.36111 5.25016 3.58333C5.47238 3.80556 5.5835 4.07778 5.5835 4.4C5.5835 4.72222 5.47238 4.99444 5.25016 5.21667C5.02794 5.43889 4.75572 5.55 4.4335 5.55ZM2.3335 14.6667C2.05572 14.6667 1.81961 14.5694 1.62516 14.375C1.43072 14.1806 1.3335 13.9444 1.3335 13.6667V8.45H3.36683V7.51667C3.36683 7.17222 3.48627 6.87778 3.72516 6.63333C3.96405 6.38889 4.25572 6.26667 4.60016 6.26667C4.81127 6.26667 5.00294 6.31111 5.17516 6.4C5.34738 6.48889 5.50572 6.61111 5.65016 6.76667L6.60016 7.83333C6.68905 7.93333 6.79183 8.03333 6.9085 8.13333C7.02516 8.23333 7.16683 8.33889 7.3335 8.45H14.6668V13.6667C14.6668 13.9444 14.5696 14.1806 14.3752 14.375C14.1807 14.5694 13.9446 14.6667 13.6668 14.6667H2.3335ZM12.3668 6.66667L12.3835 6.46667C12.4168 6.02222 12.3696 5.67222 12.2418 5.41667C12.1141 5.16111 11.9335 4.86667 11.7002 4.53333C11.4335 4.15556 11.2418 3.76111 11.1252 3.35C11.0085 2.93889 10.9724 2.53889 11.0168 2.15L11.0335 2H11.9335L11.9168 2.23333C11.8946 2.62222 11.9224 2.93889 12.0002 3.18333C12.0779 3.42778 12.2446 3.71667 12.5002 4.05C12.7779 4.40556 12.9891 4.80833 13.1335 5.25833C13.2779 5.70833 13.3279 6.12778 13.2835 6.51667L13.2668 6.66667H12.3668ZM9.70016 6.66667L9.71683 6.46667C9.75016 6.02222 9.70294 5.67222 9.57516 5.41667C9.44738 5.16111 9.26683 4.86667 9.0335 4.53333C8.76683 4.15556 8.57516 3.76111 8.4585 3.35C8.34183 2.93889 8.30572 2.53889 8.35016 2.15L8.36683 2H9.26683L9.25016 2.23333C9.22794 2.62222 9.25572 2.93889 9.3335 3.18333C9.41127 3.42778 9.57794 3.71667 9.8335 4.05C10.1113 4.40556 10.3224 4.80833 10.4668 5.25833C10.6113 5.70833 10.6613 6.12778 10.6168 6.51667L10.6002 6.66667H9.70016ZM11.3335 13.6667H13.1668V9.45H11.3335V13.6667ZM8.50016 13.6667H10.3335V9.45H8.50016V13.6667ZM5.66683 13.6667H7.50016V9.45H5.66683V13.6667ZM2.8335 13.6667H4.66683V9.45H2.8335V13.6667Z" />
    </svg>
  );

  function getProps() {
    return {
      "aria-label": props["aria-label"],
      className,
      height: size,
      role,
      strokeWidth: "0",
      style,
      viewBox: "0 0 16 16",
    };
  }
};

HotTub.displayName = "HotTubIcon";

HotTub.propTypes = {
  /** aria-label text to provide accessibility description for this SVG element. */
  "aria-label": PropTypes.string,

  /**
   * Additional classes for positioning the component. Given classes may only position this component for layout
   * purposes, and cannot change how the component renders in any way.
   */
  className: PropTypes.string,

  /** Name used for aria role. */
  role: PropTypes.string,

  /** Indicates icon's height. The width will be sized accordion to SVG's aspect ratio. */
  size: PropTypes.string,

  /**
   * CSS object to applied to SVG element. Currently, style is expected to only define stroke and fill color, but
   * there is not such a restriction or requirement at this time.
   */
  style: PropTypes.object,
};

HotTub.defaultProps = { role: "img" };
